<template>
  <div>
    <report-view
      :value="reportData"
      :chart-toolbox="true"
      :isDefaultChart="true"
      :hideManeuversSection="true"
      v-if="showData"
    >
      <b-container
        slot="chart-header-content"
        class="px-0"
        fluid
      >
        <b-row>
          <b-col>
            <div class="latest-maneuver__maneuver-header-data-item">
              <label>{{ $t('entities.asset') }}:</label>
              <span>{{ maneuverData.assetName }}</span>
            </div>
            <div class="latest-maneuver__maneuver-header-data-item">
              <label>{{ $t('sensors.latest-maneuvers.maneuver') }}:</label>
              <span>{{ $t(`enums.maneuver-type.${maneuverData.maneuverType}`) }}</span>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <b-row slot="chart-summary-row">
        <b-col
          class="latest-maneuver__maneuver-data"
        >
          <div class="latest-maneuver__maneuver-data-item">
            <label>{{ $t('sensors.latest-maneuvers.maneuver') }}:</label>
            <span>{{ maneuverData.maneuverId }}</span>
          </div>
          <div class="latest-maneuver__maneuver-data-item">
            <label>{{ $t('sensors.latest-maneuvers.maneuver-date') }}:</label>
            <date-time-label :value="maneuverData.dateTime" />
          </div>
        </b-col>
      </b-row>
    </report-view>
    <s-empty-list
      v-else
      class="mt-5"
      size="lg"
      :loading="loading"
    />
  </div>
</template>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.latest-maneuver
  &__maneuver-data
    padding-top: 1em
  &__maneuver-header-data-item
    +media-min-lg
      label
        width: 5.5em
  &__maneuver-data-item
    +media-min-lg
      display: inline-block
      white-space: nowrap
      &:not(:last-child)
        margin-right: 1em
</style>

<script>
import ReportView from '@/domain/components/generalPanel/reports/oscillography';
import loadingMixIn from '@/services/loadingMixin';
import LatestManeuversService from '@/domain/services/installation/supervision/sensors/latestManeuvers';

export default {
  components: {
    ReportView,
  },
  mixins: [
    loadingMixIn,
  ],
  props: {
    sensorId: String,
    maneuverType: String,
  },
  data: () => ({
    reportData: null,
  }),
  computed: {
    maneuverData() {
      return this.reportData && this.reportData.maneuvers[0];
    },
    showData() {
      return !this.loading && this.maneuverData;
    },
  },
  created() {
    this.getReportData();
  },
  methods: {
    getReportData() {
      this.startLoading();
      LatestManeuversService
        .getMoreDetailsData(
          this.sensorId,
          this.maneuverType,
        ).then((reportData) => {
        this.reportData = reportData;
      }).finally(() => {
        this.endLoading();
      });
    },
  },
};
</script>
